import Vue from 'vue'
import App from './App.vue'
import axios from 'axios';
import router from './router/index.js'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import "@/style/quill.core.css";
import './style/normalize.css'

Vue.config.productionTip = false

new Vue({
  router,
  axios,
  render: h => h(App),
}).$mount('#app')
